module.exports = __webpack_public_path__ + "4ae7b1c657b1cfe5ae1fa1b1ecfe1278.png";